import { render } from "./base_frame.vue?vue&type=template&id=712acb49&scoped=true"
import script from "./base_frame.vue?vue&type=script&lang=js"
export * from "./base_frame.vue?vue&type=script&lang=js"

import "./base_frame.vue?vue&type=style&index=0&id=712acb49&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712acb49"]])

export default __exports__